<app-info-icon></app-info-icon>
<section>
  <header>
    <span>{{ title }}</span>
  </header>
  <div>
    <p>
      {{ body }}
      @if (isAddUserToSessionEnabled$ | async) {
        <span>
          You can also transfer them to your device if you're in the same room.
        </span>
      }
    </p>
  </div>
  <p>
    If this is due to a technical problem on our end, please wait a moment while we attempt to resolve it. If the problem persists, please contact support:
    <app-support-phone></app-support-phone>
  </p>
  <div class="toast-notification__action-container">
    @if (isAddUserToSessionEnabled$ | async) {
      <app-button-container>
        <app-button
          (buttonClick)="addUserToThisSession()"
          data-testid="toast-add-user-to-session"
          type="primary" [size]="'small'"
          >
          Transfer Participant(s) to this Device
        </app-button>
      </app-button-container>
    }
  </div>
</section>
